"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var runSideEffect = function runSideEffect(middlewareData, type) {
  var _middlewareData$featu, _middlewareData$featu2, _middlewareData$featu3;

  var dispatchValue = middlewareData.dispatchValue;
  var modules = middlewareData.storeModules;
  var sideEffect = type === 'log' ? middlewareData === null || middlewareData === void 0 ? void 0 : (_middlewareData$featu = middlewareData.features) === null || _middlewareData$featu === void 0 ? void 0 : _middlewareData$featu.log : type === 'run' ? middlewareData === null || middlewareData === void 0 ? void 0 : (_middlewareData$featu2 = middlewareData.features) === null || _middlewareData$featu2 === void 0 ? void 0 : _middlewareData$featu2.run : type === 'callback' ? middlewareData === null || middlewareData === void 0 ? void 0 : (_middlewareData$featu3 = middlewareData.features) === null || _middlewareData$featu3 === void 0 ? void 0 : _middlewareData$featu3.callback : null;

  if (dispatchValue !== null) {
    modules === null || modules === void 0 ? void 0 : modules.map(function (module) {
      var _module$middleware, _module$middleware2, _module$middleware3;

      var moduleSideEffect = type === 'log' ? module === null || module === void 0 ? void 0 : (_module$middleware = module.middleware) === null || _module$middleware === void 0 ? void 0 : _module$middleware.log : type === 'run' ? module === null || module === void 0 ? void 0 : (_module$middleware2 = module.middleware) === null || _module$middleware2 === void 0 ? void 0 : _module$middleware2.run : type === 'callback' ? module === null || module === void 0 ? void 0 : (_module$middleware3 = module.middleware) === null || _module$middleware3 === void 0 ? void 0 : _module$middleware3.callback : null;

      if (typeof moduleSideEffect === 'function') {
        setTimeout(function () {
          moduleSideEffect(middlewareData);
        }, 0);
      }
    });

    if (typeof sideEffect === 'function') {
      setTimeout(function () {
        sideEffect(middlewareData);
      }, 0);
    }
  }
};

var _default = runSideEffect;
exports["default"] = _default;
module.exports = exports.default;